import {
  AllAccessOrderTabs,
  RestrictedOrderTabs,
  OrderDetails,
  ProgramSummary,
} from './coordinator'

const mapStateToProps = state => {
  const { selectedOrgId, isLevelOne } = state.user.data
  const settings = state.settingsOrg[selectedOrgId] || {}
  const formTypeCode = settings?.data?.schoolInformation?.formTypeCode
  return {
    isAllAccess: !isLevelOne,
    formTypeCode,
  }
}

export default connect(mapStateToProps)(({ isAllAccess, formTypeCode }) => {
  return (
    <>
      <h2 className="sr-only">Orders</h2>
      {isAllAccess ? (
        <div className="row">
          <div className="col-xs-12">
            <ProgramSummary />
          </div>
        </div>
      ) : null}
      <OrderDetails isAllAccess={isAllAccess} />
      {isAllAccess ? (
        <div className="row">
          <div className="col-xs-12">
            <AllAccessOrderTabs isDomestic={formTypeCode === 'D'} />
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col-xs-12">
            <RestrictedOrderTabs />
          </div>
        </div>
      )}
    </>
  )
})
